import { languages } from 'prism-code-editor/prism';

var cedar = {};

languages.cedar = Object.assign(cedar, {
  comment: {
    pattern: /\/\/.*(?=$)/g,
    greedy: true,
  },
  annotation: {
    pattern: /\s*([@][_a-zA-Z][_a-zA-Z0-9]*)\(/g,
    lookbehind: true,
    greedy: true,
    alias: 'meta',
  },
  section: {
    pattern: /\b(?<!\.)(?:permit|forbid|when|unless)\b/g,
    alias: 'keyword',
  },
  keyword: /\b(?:in|has|like|if|then|else|is)\b/,
  variable: {
    pattern: /\?(?:principal|resource)\b/,
    alias: 'variable-name',
  },
  method: {
    pattern: /\.(?:contains|containsAll|containsAny)\(/,
    alias: 'function',
  },
  function: {
    pattern: /\b(?:ip|decimal)\(/,
    alias: 'function-name',
  },
  'ip-method': {
    pattern: /\.(?:isIpv4|isIpv6|isLoopback|isMulticast|isInRange)\(/,
    alias: 'function',
  },
  'decimal-method': {
    pattern: /\.(?:lessThan|lessThanOrEqual|greaterThan|greaterThanOrEqual)\(/,
    alias: 'function',
  },
  boolean: {
    pattern: /\b(?:true|false)\b/,
    alias: 'constant',
  },
  number: {
    pattern: /\b([1-9]+[0-9]*|0)\b/,
    alias: 'constant',
  },
  constant: {
    pattern: /\b(?<!\.)(?:principal|action|resource|context)\b/,
    alias: 'variable-constant',
  },
  entity: {
    pattern:
      /\b((?:[_a-zA-Z][_a-zA-Z0-9]*::)*[_a-zA-Z][_a-zA-Z0-9]*)(?:::)(?=")/,
    lookbehind: false,
    alias: 'entity-name',
  },
  'namespaced-type': {
    pattern: /\b((?:[_a-zA-Z][_a-zA-Z0-9]*::)+[_a-zA-Z][_a-zA-Z0-9]*)\b/,
    lookbehind: false,
    alias: 'class-name',
  },
  string: {
    pattern: /"(?:\\.|[^\\"])*"/g,
    greedy: true,
    inside: {
      escape: {
        pattern: /\\./,
        alias: 'escape-character',
      },
    },
  },
  punctuation: /[{}[\](),.;:]/,
});

// Add cedar-specific aliases
cedar['entity'].alias = 'entity-name';
cedar['namespaced-type'].alias = 'class-name';

export default cedar;
